import styled from "@emotion/styled";

import { pluralise } from "../../lib/utils";
import { Flex, Text } from "../../styles/utility-components";
import { BulkSaveLeadButton } from "../leads/saving/BulkSaveLeadButton";
import Button from "../ui/button/Button";

export default function ContactsActionBar({
  selectedIds,
  onClearSelection,
}: {
  selectedIds: string[];
  onClearSelection: () => void;
}) {
  return (
    <Container aria-label="Contacts bulk action bar">
      <Flex gap={16} alignItems="center">
        <Text color="white">{pluralise(selectedIds.length, "contact")} selected:</Text>
        <ActionButtonWrapper>
          <BulkSaveLeadButton
            entities={selectedIds.map((entityId) => ({ entityType: "contact", entityId }))}
          />
        </ActionButtonWrapper>
      </Flex>
      <Flex gap={8} alignItems="center">
        <Button icon="xClose" onClick={onClearSelection}>
          Deselect all
        </Button>
      </Flex>
    </Container>
  );
}

const Container = styled(Flex)(({ theme }) => ({
  justifyContent: "space-between",
  alignItems: "center",
  height: 48,
  padding: 8,
  backgroundColor: theme.colors.sysPrimaryDefault,
  borderRadius: 4,
  boxShadow: "0px 2px 8px 0px rgba(0, 0, 0, 0.12)",
}));

const ActionButtonWrapper = styled.div(({ theme }) => ({
  border: `1px solid ${theme.colors.sysTextWhite}`,
  borderRadius: 4,
  position: "relative",
}));
